import { Point } from "../../engine/space/bounds";
import { gameData } from "../GameManager";
import { FloorTypes } from "./Map";

export const moveToEmpty = (to: Point) => {
  const tile = gameData.current.tiles[to.x + to.y * gameData.current.width];
  return tile && tile.type === FloorTypes.EMPTY;
};
